import api from './api';
import logAxiosError from '../utils/LogAxiosError.jsx';


const getDataVisualization = async () => {
    try {
      const response = await api.get('/api/data-visualization/');
      return response.data;
    } catch (error) {
      logAxiosError(error);
      throw error;
    }
  };
  
  export default getDataVisualization;